import Vue from "vue"
import Component from "vue-class-component"
import { Editor, Writer } from "types"

@Component
export default class EditableMixin extends Vue {
  public editable(
    articleId: number,
    status: string,
    editor: Editor,
    writer: Writer,
    adminUserId: number,
    role: string
  ) {
    if (role === "writer") {
      if (articleId) {
        // 記事更新
        return (
          writer != null &&
          writer.name != null &&
          writer.id === adminUserId &&
          status === "編集中"
        )
      } else {
        // 新規作成時
        return true
      }
    } else if (role === "editor") {
      if (articleId) {
        // 記事更新
        return true
      } else {
        // 新規作成時
        return true
      }
    } else if (role === "administrator") {
      return true
    } else {
      return false
    }
  }
}
